import React from 'react'
import PropTypes from 'prop-types'

function HelpIcon({ height, width, fill }) {
  return (
    <svg fill={fill} height={height} width={width} version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
      <path d="m600 100c-132.61 0-259.79 52.68-353.55 146.45-93.766 93.77-146.45 220.95-146.45 353.55s52.68 259.79 146.45 353.55c93.77 93.766 220.95 146.45 353.55 146.45s259.79-52.68 353.55-146.45c93.766-93.77 146.45-220.95 146.45-353.55 0-87.77-23.102-173.99-66.988-250-43.883-76.008-107-139.13-183.01-183.01-76.008-43.887-162.23-66.988-250-66.988zm50 735.5c0 3.8438-1.5273 7.5352-4.2461 10.254s-6.4102 4.2461-10.254 4.2461h-71c-3.8438 0-7.5352-1.5273-10.254-4.2461s-4.2461-6.4102-4.2461-10.254v-71c0-3.8438 1.5273-7.5352 4.2461-10.254s6.4102-4.2461 10.254-4.2461h71c3.8438 0 7.5352 1.5273 10.254 4.2461s4.2461 6.4102 4.2461 10.254zm92-312c-4.7031 12.949-11.094 25.219-19 36.5-8 10.5-18 22.5-30.5 36.5-9.8047 10.449-18.988 21.469-27.5 33-7.2305 9.5781-12.961 20.199-17 31.5-4.582 12.496-6.9492 25.691-7 39h-100c0.19141-17.051 3.2344-33.953 9-50 4.7773-13.98 11.691-27.137 20.5-39 8-11 18.5-23.5 31.5-38s18.5-21 24.5-28.5c5.875-8.1328 10.898-16.844 15-26 3.6875-9.7422 5.5508-20.082 5.5-30.5 1.3008-13.855-3.2266-27.625-12.5-38-9.7422-8.4062-22.352-12.734-35.203-12.086-12.852 0.65234-24.957 6.2344-33.797 15.586-4.25 4.9883-7.4766 10.766-9.5 17v17 3c-1.7578 0.75-3.7422 0.75-5.5 0h-92.5c-1.7969 0.51562-3.7031 0.51562-5.5 0-1.8633-1.8242-2.7852-4.4062-2.5-7 0.48047-8.6484 1.9922-17.211 4.5-25.5 2.8516-15.297 8.2617-30 16-43.5 11.191-21.367 28.633-38.809 50-50 24.984-11.043 52.227-16.012 79.5-14.5 27.75-0.67578 55.332 4.4336 81 15 20.586 9.0156 38.004 23.992 50 43 12.676 20.582 19.262 44.332 19 68.5 0.27734 16.027-2.4375 31.965-8 47z"/>
    </svg>
  )
}

HelpIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  fill: PropTypes.string,
}

HelpIcon.defaultProps = {
  width: '2em',
  height: '2em',
  fill: '#000000',
}

export default HelpIcon
